import React from 'react';
import { Modal } from 'antd';
import ImagePreview from './ImgPreviewContent';
import CloseIcon from '../Icons/svgs/CloseMailSvg';
import style from './imgPreview.module.scss';
const ImgPreviewModal = props => (React.createElement(Modal, Object.assign({ centered: true, footer: null, className: style.modal, closeIcon: React.createElement(CloseIcon, null) }, props),
    React.createElement(ImagePreview, Object.assign({}, props))));
export default ImgPreviewModal;
